/* eslint-disable no-unsafe-optional-chaining */
import React from 'react';
import DeployedTokenCube from './DeployedTokenCube';
import { getDefaultZoneName, getMyTokenFill, getZoneCatByZoneArea } from './court.data';
import { useSelector } from 'react-redux';

const X_START = 1.00;
const Y_START = 1.11;
const X_STEP = 19.20;
const Y_STEP = 25.59;

const DeployedTokens = ({ purchasedTokens, disableTokenHover }) => {
  const { currentSeason } = useSelector((state) => state.seasons);

  return (
    <>
      {purchasedTokens?.map((token, key) => {
          // TRANSLATION LOGIC: Convert grid index (0-59) to screen pixels
          const screenX = X_START + (token?.positionWithinCourt?.xAxis * X_STEP);
          const screenY = Y_START + (token?.positionWithinCourt?.yAxis * Y_STEP);

          return (
            <DeployedTokenCube
              key={key}
              onClick={token?.onClick ? token?.onClick : () => {}}
              position={{ x: screenX, y: screenY }}
              totalCount={token?.tokenCount}
              fill={getMyTokenFill(parseInt(getZoneCatByZoneArea(getDefaultZoneName(currentSeason?.zoneCategories, token?.zoneName))))}
              highlighted={token?.highlighted}
              disableTokenHover={disableTokenHover}
            />
          );
      })}
    </>
  );
};

export default DeployedTokens;
